import logo from './logo.svg';
import './App.css';
import store from './store';
import {Provider} from 'react-redux';
import Navheader from './Components/Navheader';
import Background from './Components/Background';
import Element from './Components/Element';
import styles from './Components/styles.module.scss';
import Button from './Components/Button';
import Card from './Components/Card';
import Footer from './Components/Footer';
import Vid from './Components/Vid';
import { useParams } from 'react-router-dom';
import Game from './Components/Game';
import GamePane from './Components/GamePane';
function Games(props) {
  const {id} = useParams();

const gameArray = [...props.games].sort((a, b) => a.order - b.order);
  const gameCardsArray = props.gameCards;
   const horrorGameArray = props.horrorGames;

  let elementArray = [];

  for(let i = 0; i < 3; i++){
    elementArray.push(<Element halloween={props.halloween} xmas={props.xmas} key={i} height={"33P"} background={i}></Element>);
  }

console.log(elementArray);
  return (

    <div className="App"
    style={{
      width: '100%',
      background:'black',
      overflowX: "hidden"
    }}>
    <Background></Background>
    <Element halloween={props.halloween} xmas={props.xmas} height={"10P"} background={2}></Element>
    <Element halloween={props.halloween} xmas={props.xmas} height={"90P"} background={7} flexColumn={false}>
      
      {gameArray.map((val)=>{return <Game halloween={props.halloween} xmas={props.xmas} key={val.id} gameData={val} title={val.name} icon={val.icon}></Game>})}
       
    
       
       <Element halloween={props.halloween} xmas={props.xmas} height={"10P"} background={2}></Element>
    </Element>
    
      {id != null && gameArray.map((val)=>{
        if(parseInt(id.split(':')[1]) == val.id){
        return <GamePane halloween={props.halloween} xmas={props.xmas} gameData={val}></GamePane>;
        }
        })}
 

    <Navheader halloween={props.halloween} xmas={props.xmas} games={gameArray} horrorGames={horrorGameArray}></Navheader>
   
    </div>

    
  );
}

export default Games;
